import React from "react";
import { Pages } from "./pages";

export const Routes = () => {
  return (
    <>
      <Pages />
    </>
  );
};
